<div [id]="id" class="input__container" [style.width.px]="inputWidth">
  <div class="input__container--label">
    <span class="input__container--label-name" *ngIf="!innerHTMLLabel">{{labelName}}</span>
    <span class="input__container--label-name" *ngIf="innerHTMLLabel" [innerHTML]="innerHTMLLabel"></span>
    <span *ngIf="isRequired" class="input__container--label-required">{{'custom_circuit_custom_fields_required' |
      translate}}</span>
  </div>
  <input (blur)="onBlur(this)" autocomplete="new-password" [maxLength]="maxLength" [minLength]="minLength" [max]="max" [min]="min"
    [readOnly]="readOnly" [ngClass]="{'signaturit_input_disabled': isDisabled, 'signaturit_input': !isDisabled, 'isRequired': showError}"
    [disabled]="isDisabled" type="{{inputType}}" placeholder="{{placeholderName}}" [(ngModel)]="inputValue"
    [required]="isRequired" (input)="changeText(this)" (keyup.enter)="onEnterKeyPressed($event)"
    (keydown)="onKeyDown($event)">
  <ng-container *ngIf="isPassword">
    <mat-icon class="password" (click)="viewPassword()">{{ iconPassword }}</mat-icon>
  </ng-container>
  <div class="errorContainer">
    <mat-error *ngIf="showError">
      {{messageError}}
    </mat-error>
    <mat-error *ngIf="!isCorrect">
      {{'finish_form_error_pattern' | translate}}
    </mat-error>
  </div>
</div>
